import { render, staticRenderFns } from "./SolicitacaoHistorico.vue?vue&type=template&id=1dc97bac&scoped=true&"
import script from "./SolicitacaoHistorico.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoHistorico.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoHistorico.vue?vue&type=style&index=0&id=1dc97bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc97bac",
  null
  
)

export default component.exports